<template>
  <div>
    <div class="row mt10 name-box">
      <div class="col-md-12">
        <div class="row">
          <router-link :to="localizedRoute(getMainCategory.url_path + '?designer=' + getCurrentProduct.designer)" class="fs-medium-small weight-400 cl-black author uppercase pl10">
            {{ designerCheck }}
          </router-link>
          <div id="6ea25396-b018-405b-8836-c37b4597eb3c" />
          <script defer type="application/javascript" :src="`https://trustmate.io/api/widget/6ea25396-b018-405b-8836-c37b4597eb3c/script?product=${getCurrentProduct.parentSku}`" />
        </div>
        <h1 class="mb0 mt0 product-name weight-600 serif capitalize">
          {{ getCurrentProduct.name | htmlDecode }}
          <AddToWishlist :product="getCurrentProduct" class="wishlist-button" />
        </h1>
        <div class="my10 price-wrapper">
          <p class="fs-medium-small cl-light-gray m0 text-nowrap">
            {{ getAllAttributeList('retail_price') }} {{ getCurrentProduct.retail_price | price(storeView) }}
          </p>
          <SpecialOfferLabel v-if="isSpecialOffer">
            {{ getLabelFor('info_label', getCurrentProduct.info_label) }}
          </SpecialOfferLabel>
        </div>
        <SubscriptionRent v-if="isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" />
        <SingleRent v-if="!isLogged || !isEnoughPoints || !isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" :scroll-to-try-on="scrollToTryOn" />
        <div id="try-on" />
        <TryOn v-if="isTryOn && !isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" />
      </div>
    </div>
    <product-custom-options
      v-if="getCurrentProduct.custom_options && getCurrentProduct.custom_options.length > 0"
      :product="getCurrentProduct"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ProductMixin } from 'theme/components/core/blocks/Product-v2/ProductMixin.ts'
import SingleRent from './Rent/SingleRent.vue'
import SubscriptionRent from './Rent/SubscriptionRent.vue'
import TryOn from './Rent/TryOn.vue'
import SpecialOfferLabel from 'theme/components/core/blocks/Product-v2/components/SpecialOfferLabel'
import { isServer } from '@vue-storefront/core/helpers'

export default {
  components: {
    SingleRent,
    SubscriptionRent,
    TryOn,
    SpecialOfferLabel
  },
  mixins: [ProductMixin],
  computed: {
    ...mapGetters({
      getPeriods: 'calendar/getPeriods',
      getUserBalance: 'user/getBalance',
      isLogged: 'user/isLoggedIn',
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    isSubscriptionAvaliable () {
      return this.getCurrentProduct.subscription_points
    },
    isEnoughPoints () {
      return this.getUserBalance >= 1
    },
    isTryOn () {
      // I understand that the client wanted the try-on section to always be shown on the server
      if (isServer) return true
      let dayPeriod = this.getPeriods && this.getPeriods.find(period => period === 2)
      return !!dayPeriod
    },
    firstAvailableSection () {
      if (this.isSubscriptionAvaliable) {
        return 'With membership'
      } else {
        return 'One-time rental'
      }
    },
    isFinalPrice () {
      return !!Number(this.getCurrentProduct.sirental_price.every(price => price.final_price))
    },
    isInfoLabel () {
      return this.getCurrentProduct.info_label
    },
    isSpecialOffer () {
      return this.isInfoLabel && this.isFinalPrice
    }
  },
  async mounted () {
    this.setAvaliableSourceCodes()
  },
  methods: {
    updatePeriod () {
      this.$store.dispatch('calendar/updateCalendarData')
    },
    setAvaliableSourceCodes () {
      if (this.getCurrentProduct.stock && this.getCurrentProduct.stock.source_codes && this.getCurrentProduct.stock.source_codes.length) {
        this.$store.commit('calendar/setAvailableDeliveries', this.getCurrentProduct.stock.source_codes)
      } else {
        this.$store.commit('calendar/setAvailableDeliveries', [])
      }
      this.$store.dispatch('calendar/loadCalendarData', { sku: this.getCurrentProduct.sku })
    },
    async scrollToTryOn () {
      await document.getElementsByClassName('rent-header-try-on')[0].click();
      const tryOnWrapper = document.getElementById('try-on');
      tryOnWrapper.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
</script>

<style lang="scss" scoped>
.name-box {
  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
}
.product-name {
  font-size: 28px;
  font-weight: 500;
  position: relative;
  .wishlist-button {
    position: absolute;
    right: 0;
    top: -7px;
  }
  @media (max-width: 767px) {
    font-size: 26px;
  }
}
.price-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

#try-on {
  height: 200px;
  margin-top: -200px;
}
</style>
